var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheckSalmon = function SvgCheckSalmon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5796",
    "data-name": "Grupo 5796",
    transform: "translate(-787 -327)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1709",
    "data-name": "Ret\\xE2ngulo 1709",
    width: 24,
    height: 24,
    transform: "translate(787 327)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_19",
    "data-name": "Subtra\\xE7\\xE3o 19",
    d: "M10,20a10.006,10.006,0,1,1,7.069-2.931A10.012,10.012,0,0,1,10,20ZM5.846,9.051,4.688,10.386l4.363,3.768L15.252,7,13.917,5.846,8.873,11.661,5.846,9.051Z",
    transform: "translate(789 329)",
    fill: "#FD9476"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckSalmon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-salmon.484542f8.svg";
export { ForwardRef as ReactComponent };